export interface Category {
  id: string;
  name: string;
  slug: string;
  count: number;
  icon: string;
}

export const categories: Category[] = [
  { id: "all", name: "全部", slug: "all", count: 12, icon: "ri-apps-line" },
  { id: "rexue", name: "热血", slug: "rexue", count: 4, icon: "ri-fire-line" },
  { id: "lianai", name: "恋爱", slug: "lianai", count: 4, icon: "ri-heart-line" },
  { id: "xuanhuan", name: "玄幻", slug: "xuanhuan", count: 2, icon: "ri-magic-line" },
  { id: "qihuan", name: "奇幻", slug: "qihuan", count: 5, icon: "ri-star-line" },
  { id: "xuanyi", name: "悬疑", slug: "xuanyi", count: 2, icon: "ri-search-eye-line" },
  { id: "maoxian", name: "冒险", slug: "maoxian", count: 1, icon: "ri-compass-line" },
  { id: "dushi", name: "都市", slug: "dushi", count: 1, icon: "ri-building-line" },
  { id: "xiaoyuan", name: "校园", slug: "xiaoyuan", count: 1, icon: "ri-school-line" },
  { id: "jinghong", name: "惊悚", slug: "jinghong", count: 1, icon: "ri-ghost-line" },
];